module.exports = __webpack_public_path__ + "img/help-logo.57d59587.png";